module.exports = __webpack_public_path__ + "static/media/ny-che-routes-mobile@2x.5d4fdd4f.png";